import { createSelector } from '@reduxjs/toolkit';
import { TState } from 'store/types';
import { LoginSchema } from '../loginSchema';

export const getLoginState = (state: TState): LoginSchema => state.login;

export const getIsAuth = createSelector(
  getLoginState,
  ({ auth: { isAuth } }) => isAuth,
);

export const getInitDataState = createSelector(
  getLoginState,
  ({ auth: { initDataId } }) => initDataId,
);

export const getIsAuthLoading = createSelector(
  getLoginState,
  ({ auth: { loading, error } }) => ({ loading, error }),
);

export const getRegisterLoading = createSelector(
  getLoginState,
  ({ register: { loading, error } }) => ({ loading, error }),
);

export const getReffId = createSelector(
  getLoginState,
  ({ refferal }) => refferal,
);

export const getRegPhone = createSelector(
  getLoginState,
  ({ register: { phone } }) => phone || '',
);

export const getRegName = createSelector(
  getLoginState,
  ({ register: { name } }) => name,
);

export const getRegCode = createSelector(
  getLoginState,
  ({ register: { code } }) => code || '',
);

export const getRegSurname = createSelector(
  getLoginState,
  ({ register: { surname } }) => surname,
);

export const getRegPatronymic = createSelector(
  getLoginState,
  ({ register: { patronymic } }) => patronymic,
);

export const getRegGender = createSelector(
  getLoginState,
  ({ register: { gender } }) => gender,
);

export const getRegBirth = createSelector(
  getLoginState,
  ({ register: { birth } }) => birth,
);

export const getRegEducation = createSelector(
  getLoginState,
  ({ register: { education } }) => education,
);

export const getRegAgreement = createSelector(
  getLoginState,
  ({ register: { agreement } }) => agreement,
);

export const getRegPrivacy = createSelector(
  getLoginState,
  ({ register: { privacy } }) => privacy,
);

export const getRegOwnUse = createSelector(
  getLoginState,
  ({ register: { own_respondents_use } }) => own_respondents_use,
);

export const getRegSmartCaptureToken = createSelector(
  getLoginState,
  ({ register: { smartCaptureToken } }) => smartCaptureToken,
);

export const getRegSmsMessage = createSelector(
  getLoginState,
  ({ sms: { message } }) => message,
);

export const getRegSmsLoading = createSelector(
  getLoginState,
  ({ sms: { loading } }) => loading,
);

export const getRegSmsError = createSelector(
  getLoginState,
  ({ sms: { error } }) => error,
);

//POLLS
export const getPollId = createSelector(
  getLoginState,
  ({ poll_id }) => poll_id,
);

//OWN
export const getIsRegUsingLink = createSelector(
  getLoginState,
  ({ auth: { isRegUsingLink } }) => isRegUsingLink,
);

export const getIsReenteringLink = createSelector(
  getLoginState,
  ({ auth: { isReenteringLink } }) => isReenteringLink,
);
